import { _fetch as fetchSecure } from '@hobs/utils/fetch';
import { getTokenData } from './utils';
import { constants } from './constants';

function getApiUrl() {
  return process.env.NODE_ENV === 'production' && global.config.baseApiURL
    ? global.config.baseApiURL
    : process.env.REACT_APP_API_URL;
}

function getMfaSessionTokenName() {
  return `mfaSessionToken-${getApiUrl()}`;
}

export function login(username, password) {
  return dispatch => {
    dispatch(request({ username }));

    const API_URL = getApiUrl();

    const mfaSessionToken = localStorage.getItem(getMfaSessionTokenName());

    return fetch(`${API_URL}/Account/Login`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ username, password, mfaSessionToken })
    })
      .then(response => response.json())
      .then(response => {
        if (response.token) {
          localStorage.setItem('token', JSON.stringify(response.token));
          dispatch(
            success({
              ...response,
              ...getTokenData(response.token)
            })
          );

          return { success: true };
        } else if (
          response.isMfaEnabled &&
          !response.isMfaValid &&
          response.mfaUnverifiedToken
        ) {
          dispatch(failure(response.toString()));

          localStorage.setItem(
            'mfaUnverifiedToken',
            response.mfaUnverifiedToken
          );

          return { success: false, isMfaValidationNeeded: true };
        } else {
          dispatch(failure(response.toString()));

          return { success: false, ...response };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));
      });
  };

  function request(user) {
    return { type: constants.LOGIN_REQUEST, user };
  }
  function success(user) {
    return { type: constants.LOGIN_SUCCESS, user };
  }
  function failure(error) {
    return { type: constants.LOGIN_FAILURE, error };
  }
}

export function submitMfaVerificationToken(verificationToken) {
  return dispatch => {
    const mfaSessionToken = localStorage.getItem(getMfaSessionTokenName());
    const body = { verificationToken, mfaSessionToken };
    const mfaUnverifiedToken = localStorage.getItem('mfaUnverifiedToken');

    return fetchSecure('Account/submit-verification-token', {
      method: 'POST',
      body: body,
      token: mfaUnverifiedToken
    }).then(response => {
      if (response.status == 200) {
        var payload = response.payload;
        if (payload.token) {
          localStorage.setItem('token', JSON.stringify(payload.token));
          localStorage.removeItem('mfaUnverifiedToken');

          dispatch(
            success({
              ...payload,
              ...getTokenData(payload.token)
            })
          );

          return { success: true };
        }
      }

      return {
        success: false,
        message: response.payload.message,
        lockoutEnabled: response.payload.lockoutEnabled
      };
    });

    function success(user) {
      return { type: constants.LOGIN_SUCCESS, user };
    }
  };
}

export function requestMfaTokenByEmail() {
  return () => {
    const mfaSessionToken = localStorage.getItem(getMfaSessionTokenName());
    const body = { mfaSessionToken };
    const mfaUnverifiedToken = localStorage.getItem('mfaUnverifiedToken');

    return fetchSecure('Account/send-verification-token', {
      method: 'POST',
      body: body,
      token: mfaUnverifiedToken
    }).then(response => {
      if (response.status == 200) {
        localStorage.setItem(
          getMfaSessionTokenName(),
          response.payload.mfaSessionToken
        );
        return { success: true };
      }
      return { success: false };
    });
  };
}

export function reset(userId, resetToken, password, confirmPassword) {
  return dispatch => {
    dispatch(request());

    const API_URL = getApiUrl();

    return fetch(`${API_URL}/Account/ChangePassword`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ userId, resetToken, password, confirmPassword })
    })
      .then(async response => {
        return {
          status: response.status,
          payload: await response.text()
        };
      })
      .then(response => {
        if (response.status === 200) {
          localStorage.removeItem('token');

          dispatch(success());
          return {
            success: true,
            status: response.status,
            payload: response.payload
          };
        } else {
          dispatch(failure(response.toString()));
          return {
            success: false,
            status: response.status,
            payload: JSON.parse(response.payload)
          };
        }
      })
      .catch(error => {
        dispatch(failure(error.toString()));

        return {
          success: false,
          payload: {}
        };
      });
  };

  function request() {
    return { type: constants.RESET_REQUEST };
  }
  function success() {
    return { type: constants.RESET_SUCCESS };
  }
  function failure(error) {
    return { type: constants.RESET_FAILUTER, error };
  }
}

export function updateToken(token) {
  return dispatch => {
    localStorage.setItem('token', JSON.stringify(token));
    dispatch({
      type: constants.LOGIN_UPDATE,
      user: {
        token,
        ...getTokenData(token)
      }
    });
  };
}

export function logout() {
  return dispatch => {
    localStorage.removeItem('token');

    return fetchSecure('Account/Logout', { method: 'POST' })
      .then(() => {
        dispatch({ type: constants.LOGOUT });
      })
      .catch(() => {
        dispatch({ type: constants.LOGOUT });
      });
  };
}
